import { useCallback, useState } from "react";
import { useHistory } from "react-router";

const getTargetProductId = (product) => product.product_id;

export function useProductSelection(customImageProducts, { route } = {}) {
  const history = useHistory();
  const [customDrawerOpen, setCustomDrawerOpen] = useState(false);

  const handleProductClick = useCallback(
    (product) => {
      history.push(`/${route}/${getTargetProductId(product)}`);
    },
    [history, route],
  );

  const handleCustomGetStarted = useCallback(() => {
    if (customImageProducts.length === 1) {
      history.push(`/${route}/${customImageProducts[0]?.product_id}`);
    } else {
      setCustomDrawerOpen(true);
    }
  }, [customImageProducts, history, route]);

  const handleCustomSelect = useCallback(
    (product) => {
      setCustomDrawerOpen(false);
      history.push(`/${route}/${product?.product_id}`);
    },
    [history, route],
  );

  return {
    customDrawerOpen,
    handleProductClick,
    handleCustomGetStarted,
    handleCustomSelect,
    setCustomDrawerOpen,
  };
}
